module.exports = __webpack_public_path__ + "static/img/anxun91.13513102.png";